const windowSize = (sizeState, setSizeState) => {
  var rtime;
  var timeout = false;
  var delta = 300;

  const setSize = () => {
    setSizeState(window.innerWidth);
  };

  const resizeend = () => {
    if (new Date() - rtime < delta) {
      setTimeout(resizeend, delta);
    } else {
      timeout = false;
      setSize();
    }
  };

  window.addEventListener("resize", () => {
    rtime = new Date();
    if (timeout === false) {
      timeout = true;
      setTimeout(resizeend, delta);
    }
  });
};

export default windowSize;
